
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/[offerSlug]",
      function () {
        return require("private-next-pages/marketplace/[offerSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/[offerSlug]"])
      });
    }
  